import React from "react";
import copyToClip from "components/common/copyToClip";
import Utils from "Utils";

export default function Copy({ toBeCopied, content }) {
  const copy = () => {
    copyToClip(toBeCopied);
    Utils.notify("Keyword copied to clipboard", "success");
  };
  return (
    <div>
      <span>{content}</span>
      <img
        src="/logos/copy.png"
        style={{ width: 20 }}
        className="pointer"
        onClick={copy}
        title={toBeCopied}
      />
    </div>
  );
}
